import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Eye, Ticket, Users, CreditCard, Clock } from 'lucide-react';
export function PurchaseSection() {
  const [viewers, setViewers] = useState(42);
  const [spots, setSpots] = useState(13);
  const [totalAccessed, setTotalAccessed] = useState(3265);
  const [currentDate, setCurrentDate] = useState('');
  useEffect(() => {
    const today = new Date();
    const formatted = today.toLocaleDateString('es-AR', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    setCurrentDate(formatted.charAt(0).toUpperCase() + formatted.slice(1));
    const viewerInterval = setInterval(() => {
      setViewers(prev => {
        const change = Math.random() > 0.5 ? 1 : -1;
        const newValue = prev + change;
        return Math.max(35, Math.min(55, newValue));
      });
    }, 8000);
    const spotInterval = setInterval(() => {
      setSpots(prev => {
        if (prev > 2) {
          return prev - 1;
        }
        return prev;
      });
    }, 45000);
    return () => {
      clearInterval(viewerInterval);
      clearInterval(spotInterval);
    };
  }, []);
  return <section id="compra" className="py-20 px-4 bg-gradient-to-b from-[#111] to-[#0a0a0a] scroll-mt-20 pt-[45px] pb-[45px]" data-id="element-203">
      <div className="max-w-4xl mx-auto" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-205">
          <h2 className="md:text-6xl font-black text-white mb-8 text-[28px]" data-id="element-206">
            FORMACIÓN EN DETALLADO AUTOMOTOR
          </h2>
        </motion.div>

        <div className="bg-[#1a1a1a] border-2 border-brand-yellow/30 rounded-3xl p-8 md:p-12 shadow-2xl mb-12" data-id="element-207">
          <div className="bg-gradient-to-r from-red-500/20 to-orange-500/20 border border-red-500 rounded-xl p-2.5 mb-6 max-w-md mx-auto pt-[3px] pb-[3px] pl-[22px] pr-[22px]" data-id="element-208">
            <div className="flex items-center justify-center gap-2 flex-wrap" data-id="element-209">
              <Clock className="w-4 h-4 text-red-500" data-id="element-210" />
              <p className="text-xs md:text-sm font-black text-white text-center" data-id="element-211">
                OFERTA VÁLIDA SOLO POR HOY:{' '}
                <span className="text-red-400" data-id="element-212">{currentDate}</span>
              </p>
            </div>
          </div>

          <div className="text-center mb-8" data-id="element-213">
            <p className="text-gray-400 line-through mb-3 text-[16px]" data-id="element-214">
              Antes $49.990 ARS
            </p>
            <div className="relative inline-block" data-id="element-215">
              <p className="md:text-7xl font-black text-white pt-[0px] pb-[0px] pl-[0px] pr-[0px] mt-[0px] mb-[0px] ml-[0px] mr-[0px] text-[40px]" data-id="element-216">
                $19.990 <span className="text-4xl" data-id="element-217">ARS</span>
              </p>
              <div className="absolute -inset-4 bg-brand-yellow/10 blur-xl -z-10" data-id="element-218" />
            </div>

            <div className="relative inline-flex items-center bg-gradient-to-r from-green-600 to-green-700 text-white px-6 py-3 rounded-xl font-bold text-lg overflow-hidden group pt-[0px] pb-[0px] pl-[18px] pr-[18px] mt-[0px] mb-[0px] ml-[0px] mr-[0px] gap-[10px]" data-id="element-219">
              <CreditCard className="w-5 h-5" data-id="element-220" />
              <span className="pt-[0px] pb-[0px] pl-[0px] pr-[0px] mt-[0px] mb-[0px] ml-[0px] mr-[0px] text-[16px]" data-id="element-221">
                Hasta 3 cuotas sin interés
              </span>
              <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent to-white opacity-40 animate-shine" data-id="element-222" />
            </div>
          </div>

          <a href="https://booknova.shop/cart/56939082055840:1" target="_blank" rel="noopener noreferrer" className="relative overflow-hidden group hover:bg-[#E8B830] text-black font-extrabold py-5 px-10 rounded-2xl text-lg md:text-2xl flex gap-3 transition-all duration-300 transform hover:scale-105 shadow-[0_0_50px_rgba(212,160,23,0.5),0_0_100px_rgba(212,160,23,0.2)] w-full uppercase tracking-wider items-center justify-center whitespace-nowrap border-2 border-[#E8B830] bg-[#FFCA00]" data-id="element-223">
            <span className="relative z-10" data-id="element-224">SÍ, QUIERO LA OFERTA AHORA</span>
            <span className="text-2xl md:text-3xl relative z-10" data-id="element-225">→</span>
            <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent to-white opacity-40 group-hover:animate-[shine_1s]" data-id="element-226" />
          </a>

          <div className="flex mt-6 bg-[#0a0a0a] border border-gray-800 rounded-xl px-5 py-3 pt-[0px] pb-[0px] gap-[15px] items-center justify-center" data-id="element-227">
            <div className="flex items-center gap-2" data-id="element-228">
              <div className="relative" data-id="element-229">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse-glow" data-id="element-230" />
                <div className="absolute inset-0 w-2 h-2 bg-green-500 rounded-full animate-ping" data-id="element-231" />
              </div>
              <Eye className="w-4 h-4 text-green-500" data-id="element-232" />
              <span className="text-sm font-bold text-gray-400" data-id="element-233">
                Mirando ahora:
              </span>
              <span className="text-lg font-black text-green-500" data-id="element-234">
                {viewers}
              </span>
            </div>
            <div className="h-6 w-px bg-gray-700" data-id="element-235" />
            <div className="flex items-center gap-2" data-id="element-236">
              <Ticket className="w-4 h-4 text-red-500" data-id="element-237" />
              <span className="text-sm font-bold text-gray-400" data-id="element-238">Cupos:</span>
              <span className="text-lg font-black text-red-500" data-id="element-239">{spots}</span>
            </div>
          </div>

          <div className="mt-8 flex flex-col items-center gap-6" data-id="element-240">
            <img src="https://cdn.magicpatterns.com/uploads/u7qFqp7GX1Yb1ifMErU2CL/Mercado_Pago.jpg" alt="Medios de pago - Mercado Pago" className="w-full max-w-md rounded-xl" data-id="element-241" />
            <div className="flex items-center justify-center gap-6" data-id="element-242">
              <img src="https://cdn.magicpatterns.com/uploads/ptNbA1jXBiQTsMBRUcEdGs/garantia_7_dias.png" alt="Garantía 7 días" className="w-20 h-20 md:w-24 md:h-24 object-contain" data-id="element-243" />
              <img src="https://cdn.magicpatterns.com/uploads/5M5t52d6XS2MrGP26UXcKi/compra_asegurada.png" alt="Compra segura" className="h-14 md:h-18 object-contain" data-id="element-244" />
            </div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex justify-center mt-12" data-id="element-245">
          <div className="relative w-full max-w-[320px] aspect-[9/16] rounded-[2rem] overflow-hidden border-4 border-brand-yellow/20 shadow-[0_0_50px_rgba(245,197,24,0.15)] bg-black" data-id="element-246">
            <video src="https://cdn.magicpatterns.com/uploads/k9nZMpvPKXJ251EnCNN7kU/0420%20(1).mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-247" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none" data-id="element-248" />
          </div>
        </motion.div>
      </div>
    </section>;
}